// extracted by mini-css-extract-plugin
module.exports = {"list__table":"templateList_list__table__1LvaY","action-column":"templateList_action-column__1GbNq"};